
import { createStore } from 'vuex'
import { localGet } from '@/utils/index'
export default createStore({
  state: {
    user: {
      branch_name: '',
      terminal_name: '',
      token_str: '',
      token_timeout: 0,
      user_code: '',
      user_name: '',
      work_date: ''
    }
  },
  mutations: {
    initUserLoal (state) {
      if (localGet('token') == '' || localGet('token') == undefined) {
        return
      }

      state.user = localGet('token')
    },
    initUser (state, payload) {
      state.user = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
